/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { QnaMakerSourcesSwaggers } from 'src/qnaMaker/core/services/sources/qnaMakerSourcesSwaggers';
import { QnaMakerSourceStore } from 'src/qnaMaker/core/stores/QnaMakerSourceStore';

export const qnaSourceSwaggerToQnaSourceStore = (swagger: QnaMakerSourcesSwaggers): QnaMakerSourceStore =>
    new QnaMakerSourceStore({
        url: swagger.sourceUri,
        kind: swagger.sourceKind,
        source: swagger.source,
        name: swagger.displayName,
        contentStructureKind: swagger.contentStructureKind,
        lastUpdatedDateTime: swagger.lastUpdatedDateTime && new Date(swagger.lastUpdatedDateTime)
    });

export const qnaSourceStoreToQnaSourceSwagger = (store: QnaMakerSourceStore): QnaMakerSourcesSwaggers => ({
    displayName: store.name,
    source: store.source,
    sourceUri: store.url,
    sourceKind: store.kind,
    contentStructureKind: store.contentStructureKind,
    lastUpdatedDateTime: store.lastUpdatedDateTime?.toString()
});
